import React from "react";
import styled from "styled-components";
import { Repeater, types } from "react-bricks/frontend";
import { InfoCardProps } from "./InfoCard";
import { color } from "styles/colours";
import { getVerticalPadding, VerticalPadding, verticalPadSideProp } from "../utils/verticalPadding";

interface InfoCardsSectionProps {
  background?: types.IColor;
  gap: number;
  cards: types.RepeaterItems<InfoCardProps>;
  paddingVertical?: VerticalPadding;
  imageType: "icon" | "cover";
}

export const InfoCardSection: types.Brick<InfoCardsSectionProps> = ({
  cards,
  gap,
  background,
  paddingVertical,
  imageType,
}) => {
  return (
    <InfoCardsWrapper
      backgroundColor={background.color}
      gap={gap}
      pad={getVerticalPadding(paddingVertical)}
    >
      <Repeater propName="info-cards" items={cards} itemProps={{ imageType }} />
    </InfoCardsWrapper>
  );
};

InfoCardSection.schema = {
  name: "cards-section",
  label: "Info Cards",
  category: "Product Cards Components",
  previewImageUrl: "/static/bricks/product-cards.png",
  // Define repeaters for child bricks
  repeaterItems: [
    {
      name: "info-cards",
      itemType: "info-card",
      itemLabel: "Info Cards",
      min: 1,
      max: 5,
    },
  ],
  // Define default props
  getDefaultProps: () => ({
    background: { color: color.white },
    gap: 2,
    verticalPadding: "s",
    imageType: "icon",
    cards: [
      {
        title: "Group Health Insurance",
        content:
          "Covers the cost of high-quality healthcare, quickly, if employees were to get ill. Provided by Bupa.",
        height: 22,
        width: 25,
        hasLink: true,
        linkText: "Learn more",
        linkUrl: "#",
        verticalPadding: 3,
        horizontalPadding: 2,
        imageType: "icon",
      },
    ],
  }),
  // Define side edit props
  sideEditProps: [
    {
      name: "backgroundColor",
      label: "Background Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { label: "White", value: { color: color.white } },
          { label: "Gray", value: { color: color.B210 } },
        ],
      },
    },
    {
      name: "gap",
      label: "Gap",
      type: types.SideEditPropType.Number,
      shouldRefreshStyles: true,
    },
    {
      name: "imageType",
      label: "Image type",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Radio,
        options: [
          { label: "Icon", value: "icon" },
          { label: "Cover", value: "cover" },
        ],
      },
    },
    verticalPadSideProp,
  ],
};

export const InfoCardsWrapper = styled.section<{
  backgroundColor: string;
  gap: number;
  pad?: string;
}>`
  background: ${(p) => p.backgroundColor || color.white};
  display: flex;
  gap: ${(p) => p.gap}rem;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  row-gap: 2rem;
  ${({ pad }) => pad && `padding: ${pad} 5%;`}
`;
